module.exports = "./img/9c52bb4eb4e052fe9b49c742a7857b25.png";